<template>
  <div role="listitem" :class="isOpen ? 'open col-sm-12' : 'col-sm-12'">
    <div class="row trip-overview">
      <div class="pull-left expand-column trip-item-col">
        <a
          href="#"
          @click.prevent="toggleDetails()"
          :class="{ active: isOpen }"
          class="toggle-details-link"
        >
          <span class="sr-only"
            >{{ isOpen ? $t("detailsexpanded") : $t("detailsexpand") }}
            <span class="sr-only" lang="en" xml:lang="en"
              >departing {{ departure.from }} at
              <span v-html="to24time(departure.departure)"></span> arriving to
              {{ departure.to }} at
              <span v-html="to24time(departure.arrival)"></span></span
          ></span>
        </a>
      </div>
      <span
        v-html="to24time(departure.departure)"
        class="time-wrapper departure-time trip-item-col"
      ></span>
      <div class="text-center trip-item-col trip-item-duration">
        <span v-html="toDuration(departure.duration)"></span>
        <br />
        <span v-if="departure.segments.length > 1"
          >{{ departure.segments.length - 1 }} transfer</span
        >
        <span v-else>&nbsp;</span>
      </div>
      <span
        v-html="to24time(departure.arrival)"
        class="time-wrapper arrival-time trip-item-col"
      ></span>
      <div class="break"></div>

      <fieldset class="trip-item-col trip-fares">
        <div class="sold-out" v-if="departure.soldOut">{{ $t("soldout") }}</div>
        <legend class="sr-only">{{ $t("Select a fare class") }}</legend>
        <div
          v-for="fareClass in fareClasses"
          :key="fareClass.id"
          class="trip-fares--fare"
        >
          <input
            type="radio"
            :id="departure.id + fareClass.id + fareClass.name"
            :name="tripdir + 'FareClassSelect'"
            :value="fareClass.id"
            v-model="selectedClassId"
            @change="selectTrip(departure)"
          />
          <label :for="departure.id + fareClass.id + fareClass.name">
            <span class="visible-xs">{{ fareClass.name }}</span>
            <span class="sr-only"
              >{{ $t("select") }} {{ fareClass.name }} {{ $t("pricing") }}</span
            >
            <span class="small">{{ $t("total") }}</span>
            ${{ fareClass.fares | totalPrice(selectedFaresStore) }}
            <span class="sr-only" lang="en" xml:lang="en"
              >departing {{ departure.from }} at
              <span v-html="to24time(departure.departure)"></span> arriving to
              {{ departure.to }} at
              <span v-html="to24time(departure.arrival)"></span
            ></span>
          </label>
        </div>
      </fieldset>
    </div>
    <tripDetails
      :trip="departure"
      :fareClasses="fareClasses"
      :class="'fareclass-'"
    />
  </div>
</template>

<script>
import tripDetails from "../components/tripDetails.vue";
export default {
  props: ["departure", "tripdir", "selectedFaresStore"],
  components: {
    tripDetails,
  },
  data() {
    return {
      isOpen: false,
      selectedClassId: "",
      selectedClassName: "",
      fareClasses: "",
    };
  },
  computed: {},
  watch: {},
  created() {
    if (this.tripdir === "departure") {
      this.selectedClassId = this.$store.state.departureFareClass;
    }
    if (this.tripdir === "return") {
      this.selectedClassId = this.$store.state.returnFareClass;
    }
  },
  methods: {
    to24time: function (value) {
      var ts = value;
      var H = +ts.substr(0, 2);
      var h = H % 12 || 12;
      h = h < 10 ? "0" + h : h; // leading 0 at the left for 1 digit hours
      var ampm = H < 12 ? "<span>am</span>" : "<span>pm</span>";
      ts = h + ts.substr(2, 3) + ampm;
      return ts;
    },
    toDuration: function (value) {
      var ts = value;
      ts = ts.replace(":", " h ");
      return ts + " min";
    },
    toggleDetails() {
      this.isOpen = !this.isOpen;
    },
    sortClasses(classes) {
      function compareValues(key, order = "asc") {
        return function innerSort(a, b) {
          if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
            // property doesn't exist on either object
            return 0;
          }

          const varA =
            typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
          const varB =
            typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

          let comparison = 0;
          if (varA > varB) {
            comparison = 1;
          } else if (varA < varB) {
            comparison = -1;
          }
          return order === "desc" ? comparison * -1 : comparison;
        };
      }
      return classes.sort(compareValues("order"));
    },
    selectTrip(trip) {
      this.$store.commit("setTrip", {
        tripId: trip.id,
        selectedClassId: this.selectedClassId,
        tripdir: this.tripdir,
        tripItem: trip,
      });
    },
  },
  filters: {
    totalPrice: function (fares, selectedFaresStore) {
      return fares
        .reduce(function (total, fare) {
          const quantity = selectedFaresStore[fare.id] || 0;
          return total + Number(fare.valueToDisplay) * quantity;
        }, 0)
        .toFixed(2);
    },
  },
  mounted() {
    this.fareClasses = this.sortClasses(this.departure.fareClasses);
  },
};
</script>
<style lang="scss">
.trip-overview {
  height: 95px;
  display: flex;
  align-items: stretch;
  margin-top: 20px;
}
.trip-item-col {
  align-self: center;
}
.trip-item-duration {
  font-size: 15px;
  padding: 0px 20px;
  color: $brand-primary;
  line-height: 1.5;
  background: url("../assets/trip-arrow.svg") no-repeat center center;
  background-size: 100px;
}
.trip-fares {
  align-self: stretch;
  justify-self: end;
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  flex-grow: 1;
}
.trip-fares--fare {
  border-left: 1px solid #cecece;
  padding: 10px 40px;
  &:focus-within {
    label {
      outline: 2px dashed $brand-primary;
      outline-offset: 3px;
    }
  }
  input {
    opacity: 0;
  }
  input[type="radio"]:checked + label::after {
    position: absolute;
    top: 18px;
    left: -28px;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background-color: $brand-highlight;
    content: "";
    display: block;
    position: absolute;
  }
  label {
    color: #757070;
    font-size: 30px;
    font-weight: 300;
    font-family: $font-family-base;
    position: relative;
    &::before {
      position: absolute;
      top: 13px;
      left: -33px;
      content: "";
      border: 2px solid $brand-highlight;
      width: 25px;
      height: 25px;
      display: block;
      border-radius: 20px;
    }
    .small {
      display: block;
      font-size: 16px;
      line-height: 0.7;
    }
  }
}
.sold-out {
  padding: 10px 40px;
  margin-right: 100px;
  background-color: $brand-primary;
  color: #fff;
  font-size: 20px;
  align-self: center;
}

.toggle-details-link {
  height: 95px;
  color: $brand-primary;
  background-color: #e2edfc;
  text-decoration: none;
  display: block;
  width: 35px;
  background-image: url("../assets/expand-icon.svg");
  background-size: 18px;
  background-repeat: no-repeat;
  background-position: center center;
  &.active {
    background-image: url("../assets/collapse-icon.svg");
    background-color: $brand-primary;
  }
}
.time-wrapper {
  font-size: 30px;
  font-weight: 300;
  padding: 0px 20px;
  color: #757070;
  span {
    font-size: 15px;
  }
}
@media screen and (max-width: 768px) {
  .expand-column {
    position: absolute;
    .toggle-details-link {
      height: 176px;
      top: 0px;
      border-radius: 15px 0px 0px 15px;
    }
  }
  .trip-overview {
    flex-wrap: wrap;
    height: auto;
  }
  .time-wrapper{
    padding: 0px 13px;
  }
  .break {
    flex-basis: 100%;
    height: 0px;
  }
  .trip-fares {
    border-top: 1px solid #cecece;
  }
  .trip-fares--fare{
    padding: 10px 28px;
  }
  .trip-fares--fare:last-child{
    padding-right:13px;
  }
  .trip-fares--fare label::before {
    top: 30px;
  }
  .trip-fares--fare input[type="radio"]:checked + label::after {
    top: 35px;
  }
  .trip-fares .visible-xs {
    font-size: 15px;
  }
  .arrival-time {
    padding-top: 10px;
  }
  .arrival-time::before {
    content: "Arrival";
    font-size: 15px;
    display: block;
  }
  .departure-time {
    margin-left: 25px;
    padding-top: 10px;
  }
  .departure-time::before {
    content: "Departure";
    font-size: 15px;
    display: block;
  }
  .trip-item-duration {
    padding: 0px 13px;
  }
}
</style>